import { AppDispatch } from 'store/index';
import { tablesSlice } from 'store/reducers/tables';

export const resetTableDataAction = () => (dispatch: AppDispatch) => {
  dispatch(tablesSlice.actions.resetTableData());
  dispatch(tablesSlice.actions.setCurrentTable(''));
};
